import React from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight, Quote } from 'lucide-react';
import { reviews, averageRating } from '../data/mock';

const Reviews = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`w-4 h-4 ${
          index < rating ? 'text-primary fill-primary' : 'text-muted-foreground'
        }`}
      />
    ));
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-secondary">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading text-4xl md:text-5xl font-medium text-foreground mb-6">
              Avis clients
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              Découvrez les retours d'expérience des entreprises et particuliers 
              qui ont bénéficié de mes séances de Amma assis.
            </p>
            <div className="flex items-center justify-center gap-4">
              <div className="flex items-center gap-1">
                {renderStars(5)}
              </div>
              <span className="font-heading text-3xl font-medium text-foreground">
                {averageRating}
              </span>
              <span className="text-muted-foreground">/5</span>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="p-8 bg-white border border-border card-hover flex flex-col"
              >
                <div className="flex items-center gap-1 mb-4">
                  {renderStars(review.rating)}
                </div>
                <div className="relative flex-grow">
                  <Quote className="w-8 h-8 text-primary/20 absolute -top-2 -left-2" />
                  <p className="text-muted-foreground leading-relaxed relative z-10 pl-4">
                    {review.comment}
                  </p>
                </div>
                <div className="mt-6 pt-6 border-t border-border">
                  <p className="font-heading text-lg font-medium text-foreground">
                    {review.name}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {review.role} — {review.company}
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {review.date}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Summary Section */}
      <section className="py-24 section-gradient">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid sm:grid-cols-3 gap-8 text-center">
            <div className="p-8">
              <div className="font-heading text-5xl font-medium text-primary mb-2">
                {averageRating}
              </div>
              <p className="text-muted-foreground">Note moyenne</p>
            </div>
            <div className="p-8">
              <div className="font-heading text-5xl font-medium text-primary mb-2">
                {reviews.length}+
              </div>
              <p className="text-muted-foreground">Avis clients</p>
            </div>
            <div className="p-8">
              <div className="font-heading text-5xl font-medium text-primary mb-2">
                100%
              </div>
              <p className="text-muted-foreground">Recommandent</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-6">
            Rejoignez les entreprises satisfaites
          </h2>
          <p className="text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
            Offrez à vos collaborateurs une expérience de bien-être unique 
            et professionnelle.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary">
              Réserver une intervention
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
            <Link to="/prestations" className="btn-secondary flex items-center justify-center gap-2">
              Voir les prestations
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;
